import { useQuery } from "@tanstack/react-query";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import ConfirmCopyStatusModal from "./ConfirmCopyStatusModal";
import { DeleteAndMustMoveStatus } from "components/modals/DeleteAndMustMoveItems";

interface Props {
  data: server.dto.OptionsPanelDataV2
  status: server.dto.Status
}

const StatusDetailOptionsPanel = (props: Props) => {
  const { status, data } = props;
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [isCopying, setIsCopying] = React.useState(false);

  const statusesQuery = useQuery({
    queryFn: async () => window.CoreApi.Status.ListSmall({ clientId: status.clientId, mainArea: status.mainArea }).then(r => r.data.data),
    initialData: [],
    queryKey: ["statuses", status.mainArea, status.clientId]
  });

  const onOpenDeleteModal = () => {
    if (statusesQuery.isLoading) return;

    if (statusesQuery.data.length === 1) {
      window.displayGenericModal(RESX.Buttons.btnDelete, RESX.Status.CannotDeleteLast, "mini", "red");
      return;
    }

    setIsDeleting(true);
  };

  return <>
    <ConfirmCopyStatusModal
      status={status}
      mainArea={status.mainArea}
      isOpen={isCopying}
      onClose={() => { setIsCopying(false); }}
    />
    <DeleteAndMustMoveStatus
      statusId={status.statusId}
      afterDeleteRedirectUrl={routes.status_List(status.mainArea).absolute}
      mainArea={status.mainArea}
      clientId={status.clientId}
      isOpen={isDeleting}
      onClose={() => { setIsDeleting(false); }}
    />
    <GeneralOptionsPanel data={data} links={[{
      text: RESX.Buttons.ListView,
      href: routes.status_List(status.mainArea).absolute,
      visible: true
    }, {
      text: RESX.Buttons.btnCopy,
      onClick: () => { setIsCopying(true); },
      visible: true
    }, {
      text: RESX.Buttons.btnDelete,
      onClick: onOpenDeleteModal,
      visible: true
    }]} />
  </>;
};

export default StatusDetailOptionsPanel;